import dayjs from 'dayjs';

/**
 * Подписи календарного месяца `YYYY-MM` по-русски — одни на весь портал.
 *
 * Жили эти две функции в `pages/garage/readingNumbers.ts`, пока месяц был вопросом одного экрана.
 * Со «Статистикой» вывоза (`docs/waste-stats-tab-plan.md`) экранов стало два, и импорт из «Вывоза
 * мусора» в страницы «Гаража» связал бы два раздела форматом подписи, который не про них ни один.
 */

/** «июль 2026» из `2026-07`. Русская локаль ставится `setupDayjs`. */
export function monthLabel(month: string): string {
  return dayjs(`${month}-01`).format('MMMM YYYY');
}

/**
 * «июнь 26» — подпись под столбиком диаграммы. Год обрезан не для красоты: месяцев в периоде
 * бывает двенадцать, и полная запись «июнь 2026» под каждым из них либо наезжает на соседнюю, либо
 * заставляет вертеть подписи набок. Год при этом остаётся: период умеет пересекать новый год, и
 * два «января» подряд без него неразличимы.
 */
export function monthShort(month: string): string {
  return dayjs(`${month}-01`).format('MMM YY');
}
